import React from "react";
import {TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const LabeledStringForm = (props) => {
    const { label = "Value", data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.label)
            && strings.isNotBlank(modified.value);

        onSync(modified);
    }

    return <div className="labeled-string-form">
        <div className="field">
            <TextField
                label="Label"
                type="text"
                value={forms.sanitizeValue(data.label)}
                onChange={(event) => onChange("label", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label={label}
                type="text"
                value={forms.sanitizeValue(data.value)}
                onChange={(event) => onChange("value", event.target.value)}
            />
        </div>
    </div>

};

export default LabeledStringForm;
